import {IconButton, IconButtonProps} from '@mui/material';
import {styled} from '@mui/material/styles';
import {forwardRef} from 'react';

export type LegacyIconButtonProps = IconButtonProps;

const MuiV4SizedIconButton = styled(IconButton)({
  padding: 12,
});

const MuiV4SmallIconButton = styled(IconButton)({
  padding: 3,
});

const LegacyIconButton = forwardRef<HTMLButtonElement, LegacyIconButtonProps>(({size, ...iconButtonProps}, ref) =>
  size === 'small' ? (
    <MuiV4SmallIconButton ref={ref} size="small" {...iconButtonProps} />
  ) : (
    <MuiV4SizedIconButton ref={ref} size={size} {...iconButtonProps} />
  ),
);

LegacyIconButton.displayName = 'LegacyIconButton';

export default LegacyIconButton;
